<template>
  <div id="dashboard">
    <Navbar></Navbar>
    <DashboardHome v-if="mode == null"></DashboardHome>
    <DashboardSettings v-if="mode == 'settings'"></DashboardSettings>
    <ExplorationSettings v-if="mode == 'exploration-settings'"></ExplorationSettings>
    <EditExploration v-if="mode == 'edit-exploration'"></EditExploration>
  </div>
</template>

<script>
  import Navbar from './Navbar.vue'
  import DashboardHome from './DashboardHome.vue'
  import DashboardSettings from './DashboardSettings.vue'
  import ExplorationSettings from './ExplorationSettings.vue'
  import EditExploration from './EditExploration.vue'

  export default {
    data() {
      return {
        mode: this.$route.params.mode,
        exploration: {}
      }
    },
    watch: {
      '$route.params.mode': function (mode) {
        this.mode = mode
      }
    },
    components: { Navbar, DashboardHome, DashboardSettings, ExplorationSettings, EditExploration }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue